import React from "react";
import { IoBedOutline } from "react-icons/io5";
import { MdOutlineWaterDrop } from "react-icons/md";
import { CiTrash } from "react-icons/ci";
import { FiPhone } from "react-icons/fi";

import "./Room-Details-Card.scss";

import RoomImage from "../../../assets/images/room-image.jpeg";

const RoomDetailsCard = ({ houseDetails, careTakerDetails }) => {
  console.log("the house details", houseDetails)
  const RoomDetailsCardStyle = {
    width: "95%",
    borderRadius: "10px",
    padding: "20px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    backgroundColor: "#ffffff",
    fontFamily: "Karla, sans-serif",
    marginTop: "20px",
  };

  const imagePlaceholderStyle = {
    width: "100%",
    height: "150px",
    border: "1px solid #dcdcdc",
    borderRadius: "10px",
    marginBottom: "15px",
    objectFit: "cover", // Ensures the image covers the container while maintaining aspect ratio
    overflow: "hidden", // Hides the excess parts of the image
  };

  const RoomDetailsCardContentStyle = {
    textAlign: "left",
  };

  const titleStyle = {
    fontSize: "18px",
    margin: "0",
    color: "#333333",
  };

  const locationStyle = {
    color: "#d2a679",
    fontSize: "14px",
    marginBottom: "10px",
  };

  const detailsStyle = {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "15px",
    fontSize: "14px",
    color: "#333333",
  };

  const iconTextStyle = {
    display: "flex",
    alignItems: "center",
  };

  const priceStyle = {
    fontSize: "16px",
    fontWeight: "bold",
    color: "#333333",
  };

  //data fetch
  const formatHouseType = (houseType) => {
    const houseTypeMap = {
      single_room: "Single Room",
      bedsitter: "Bed Sitter",
      one_bedroom: "One Bedroom",
      two_bedrooms: "Two Bedroom",
      three_bedrooms: "Three Bedroom",
    };

    return houseTypeMap[houseType] || houseType;
  };

  return (
    <div className="room-details-card-container">
      <div className="room-card">
        <div className="front">
          <div style={RoomDetailsCardStyle}>
            <div>
              <img style={imagePlaceholderStyle} src={RoomImage} alt="" />
            </div>
            <div style={RoomDetailsCardContentStyle}>
              <h2 style={titleStyle}>{houseDetails?.property_name}</h2>
              <div style={locationStyle}>{houseDetails?.property_location}</div>
              <div style={detailsStyle}>
                <span style={iconTextStyle}>
                  <IoBedOutline fontSize={20} style={{ marginRight: "10px" }} />
                  <div className="">
                    {formatHouseType(houseDetails?.house_type)}
                  </div>
                </span>
                <span style={iconTextStyle}>
                  <MdOutlineWaterDrop
                    fontSize={20}
                    style={{ marginRight: "6px" }}
                  />
                  {houseDetails?.water_charge}ksh/unit
                </span>
                <span style={iconTextStyle}>
                  <CiTrash fontSize={20} style={{ marginRight: "6px" }} />{" "}
                  {houseDetails?.garbage_charge}ksh
                </span>
              </div>
              <div style={priceStyle}>ksh {houseDetails?.house_rent}</div>
            </div>
          </div>
        </div>

        <div className="back">
          <div style={RoomDetailsCardStyle}>
            <div className="contact-card">
              <div className="profile-section">
                <div className="profile-pic">
                  {/* Placeholder for profile picture */}
                </div>
                <div className="profile-info">
                  <div className="name">
                    {careTakerDetails?.name || "not yet set"}
                  </div>
                  <p className="job-title">Resident Manager</p>
                  <p className="working-hours">Working hours : 10am-12pm</p>
                </div>
              </div>

              <div className="phone-number">
                <FiPhone fontSize={20} />
                <div>{careTakerDetails?.phone_number || "not yet set"}</div>
              </div>
              <div className="button-container">
                <button className="send-message">Send Message</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoomDetailsCard;
